var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"device-manage-page"},[_c('top-bar',{attrs:{"topbarList":_vm.deviceManageTopBarList}}),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }